import { Box } from '@mui/material';
import { type GridColDef, type GridRenderCellParams } from 'esseal-data-table';

import { type ActivityRow } from './ShowActivitiesModal';

const activityColumns: GridColDef<ActivityRow>[] = [
  {
    field: 'title',
    headerName: 'Title',
    width: 180,
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 180,
    renderCell: ({ value }: GridRenderCellParams<ActivityRow>) => (value ? value : '-'),
  },
  {
    field: 'color_code',
    headerName: 'Color Code',
    width: 100,
    renderCell: ({ value }) => (
      <Box
        sx={{
          width: 50,
          height: 20,
          backgroundColor: value || '#fff',
          border: `1px solid ${value}`,
          borderRadius: 1,
        }}
      />
    ),
  },
];

export default activityColumns;
